import styles from './utils.module.scss';

export const globalStyles = styles;
